export function loadNamespacedLocales(locale: string) {
  // Import .json, .json5, and .ts files
  const allBgModules = {
    ...import.meta.glob("../modules/bg/**/*.json", { eager: true }),
    ...import.meta.glob("../modules/bg/**/*.json5", { eager: true }),
    ...import.meta.glob("../modules/bg/**/*.ts", { eager: true }),
  };
  const allEnModules = {
    ...import.meta.glob("../modules/en/**/*.json", { eager: true }),
    ...import.meta.glob("../modules/en/**/*.json5", { eager: true }),
    ...import.meta.glob("../modules/en/**/*.ts", { eager: true }),
  };
  const allMkModules = {
    ...import.meta.glob("../modules/mk/**/*.json", { eager: true }),
    ...import.meta.glob("../modules/mk/**/*.json5", { eager: true }),
    ...import.meta.glob("../modules/mk/**/*.ts", { eager: true }),
  };

  const modules = locale === "en" ? allEnModules : locale === "bg" ? allBgModules : allMkModules;
  const messages: Record<string, any> = {};

  for (const path in modules) {
    const module = modules[path] as { default: any };

    const pathParts = path
      .replace("../modules/", "")
      .replace(`${locale}/`, "")
      .replace(/\.(json5?|json|ts)$/, "") // Handle .json, .json5, and .ts
      .split("/");

    let current = messages;

    // Build nested structure
    for (let i = 0; i < pathParts.length - 1; i++) {
      const key = pathParts[i];
      if (key && !current[key]) {
        current[key] = {};
      }
      if (key) {
        current = current[key];
      }
    }

    // Set the final value
    const finalKey = pathParts[pathParts.length - 1];
    if (finalKey && module.default) {
      current[finalKey] = module.default;
    }
  }

  return messages;
}
